import type { DefaultTheme, FlattenInterpolation, ThemeProps } from 'styled-components/macro';
import styled, { css } from 'styled-components/macro';

type LoaderItemStyledT = {
  delayAnimation?: boolean;
  color?: 'white' | 'darkBlue';
  variant?: 'round' | 'brick';
};

const white = css`
  background-color: ${({ theme }): string => theme.colors.white};
`;

const darkBlue = css`
  background-color: ${({ theme }): string => theme.colors.primary.variant1};
`;

const loaderColor = {
  white,
  darkBlue,
};

const round = css<LoaderItemStyledT>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  animation: ${({ delayAnimation }): string =>
    `0.8s linear ${delayAnimation ? 0.4 : 0}s infinite round`};

  @keyframes round {
    50% {
      transform: scale(0.75);
      opacity: 0.2;
    }

    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
`;

const brick = css<LoaderItemStyledT>`
  width: 4px;
  height: 14px;
  animation: ${({ delayAnimation }): string =>
    `0.7s linear ${delayAnimation ? 0.35 : 0}s infinite brick`};

  @keyframes brick {
    50% {
      height: 6px;
      opacity: 0.2;
    }

    100% {
      height: 14px;
      opacity: 1;
    }
  }
`;

const loaderVariant = {
  round,
  brick,
};

export const LoaderWrapStyled = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const LoaderItemStyled = styled.span<LoaderItemStyledT>`
  margin: 2px;

  ${({ color = 'white' }): FlattenInterpolation<ThemeProps<DefaultTheme>> => loaderColor[color]};
  ${({ variant = 'round' }): FlattenInterpolation<ThemeProps<DefaultTheme>> =>
    loaderVariant[variant]}
`;
